<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">
          <el-form-item label="開始時間">
            <el-date-picker
              v-model="listMenuForm.startTime"
              type="month"
              placeholder="選擇時間"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="結束時間">
            <el-date-picker
              v-model="listMenuForm.endTime"
              type="month"
              placeholder="選擇時間"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="類型">
            <el-select v-model="listMenuForm.type" placeholder="請選擇類型">
              <el-option label="林距離" value="1"></el-option>
              <el-option label="其他" value="9"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="MenuBtnWrap">
        <div class="btn" @click="$router.push('/addCalendar')">新增行事曆</div>
        <div class="btn" @click="search()">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
      <div class="tableWrap">
        <el-table
          height="660px"
          stripe
          :data="calendarList"
          style="width:100%;"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in calendarListTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
          >
          </el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="$router.push('/editCalendar?id=' + scope.row.id)"
                type="text"
                >修改</el-button
              >
              <el-button @click="delCalendar(scope.row.id)" type="text"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "活動",
      navtitle: "行事曆列表",
      listMenuForm: {
        startTime: "",
        endTime: "",
        type: ""
      },
      calendarList: [],
      block: "",
      calendarListTable: [
        {
          prop: "id",
          label: "活動編號",
          width: "180"
        },
        {
          prop: "calendarName",
          label: "活動名稱",
          width: "200"
        },
        {
          prop: "calendarTime",
          label: "活動時間",
          width: "180"
        },
        {
          prop: "calendarAddress",
          label: "活動地點",
          width: "200"
        },
        {
          prop: "createTime",
          label: "發佈時間",
          width: "180"
        },
        {
          prop: "type",
          label: "類型",
          width: "80"
        }
      ],
      total: 0,
      currentPage: 1,
      dialogVisible: false
    };
  },
  // created() {
  //   this.getCalendarList();
  // },
  activated() {
    this.getCalendarList();
    // if (
    //   this.listMenuForm.startTime === "" &&
    //   this.listMenuForm.endTime === "" &&
    //   this.listMenuForm.type === "" &&
    //   this.currentPage === 1
    // ) {
    //   this.getCalendarList();
    // }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取行事历列表
    getCalendarList() {
      let startTime =
        this.listMenuForm.startTime === ""
          ? ""
          : this.$formatDate(this.listMenuForm.startTime).substring(0, 7);
      let endTime =
        this.listMenuForm.endTime === ""
          ? ""
          : this.$formatDate(this.listMenuForm.endTime).substring(0, 7);
      this.$get(
        `/calendar/activity/list?page=${this.currentPage}&size=10&startTime=${startTime}&endTime=${endTime}&type=${this.listMenuForm.type}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code === "00000") {
          this.total = res.data.total;
          res.data.list.forEach(v => {
            v.calendarTime = this.$getTime(v.calendarTime);
            v.createTime = this.$getTime(v.createTime);
            if (v.type === 1) {
              v.type = "林距離";
            } else if (v.type === 9) {
              v.type = "其他";
            }
          });
          this.calendarList = res.data.list;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCalendarList();
    },
    // 搜索行事历
    search() {
      let _this = this;
      if (
        _this.listMenuForm.startTime === "" &&
        _this.listMenuForm.endTime === "" &&
        _this.listMenuForm.type === ""
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入至少一個搜索條件", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (
        _this.$compareTime(
          _this.listMenuForm.startTime,
          _this.listMenuForm.endTime
        )
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("開始時間不能晚於結束時間", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }
      _this.$message.closeAll();
      _this.currentPage = 1;
      _this.getCalendarList();
    },
    reset() {
      this.listMenuForm = {
        startTime: "",
        endTime: "",
        type: ""
      };
      this.currentPage = 1;
      this.getCalendarList();
    },
    // 删除行事历
    delCalendar(id) {
      let _this = this;
      _this
        .$confirm("是否刪除該行事曆?", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          // 确认删除的回调
          _this.$del("/calendar/activity/" + id, {}).then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.$propMessage("刪除成功", "success", function() {
                _this.dialogVisible = false;
                _this.currentPage = 1;
                _this.getCalendarList();
              });
            }
          });
        });
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.content {
  .paddingContent {
    .ListMenu {
      .MenuBtnWrap {
        display: flex;
        justify-content: flex-end;
        .btn:last-child {
          margin-left: 0.2rem;
        }
      }
    }
    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }
    .MenuBtnWrap {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/calendarList.vue